@if (showLeftMenuOpener()) {
  <alg-left-header [compactMode]="true" />
}
<alg-content-top-bar [showBreadcrumbs]="showBreadcrumbs()"
  [showLeftMenuOpener]="showLeftMenuOpener()"
  [canDisplayPlatformLogo]="canDisplayPlatformLogo()"
 />
@if (showTopRightControls()) {
  <alg-top-right-controls [drawLeftBorder]="!modeBarDisplayed()" />
}
